import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {IOptionChainSelected} from '../irb-option-chains.model';

@Component({ standalone: false,
  selector: 'irb-option-chains-tray',
  template: `
    <div class="tray">
      <div class="tray-header add-pointer">
        @if (optionChainData.size === 0) {
          <div class="label">Click on an option above to add it to the Rebalance.</div>
        }
        @if (optionChainData.size > 0) {
          <div class="label">Selected Options for Rebalance</div>
        }
        @if (optionChainData.size > 0) {
          <div class="pointer-element" (click)="delete('all')">Delete All</div>
        }
      </div>
      @for (optionData of optionChainData | keyvalue; track optionData) {
        @for (optionSymbolData of optionData.value; track optionSymbolData) {
          <div class="pill">
            <div class="label closeButton" title="Delete" (click)="delete(optionData.key, optionSymbolData)">X</div>
            <div class="label content">
              <span class="underlyingSymbol">{{ optionData.key }}</span>
              <span class="optionSymbol">{{ optionSymbolData }}</span>
            </div>
          </div>
        }
      }
    </div>
    `,
  styleUrls: ['./option-chains-tray.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class OptionChainsTrayComponent {

  @Input()
  optionChainData: any;
  @Input()
  selectedOptionChain: Array<IOptionChainSelected>;
  @Output()
  deleteOption = new EventEmitter<string>();

  delete(symbol: string, symbolData?: string) {
    const data : any = {
      symbol:symbol, 
      symbolData: symbolData
    }
    this.deleteOption.emit(data);
  }
}
